import {
  dashboard,
  bug,
  clippy,
  alert,
  deviceDesktop,
  tasklist,
  desktopDownload,
  info,
  versions,
  verified,
  organization,
  link,
  server,
  settings,
} from "octicons-vue";

const routes = [
  {
    path: "/",
    redirect: { name: "overview" },
  },
  {
    path: "/overview",
    name: "overview",
    component: () =>
      import(/* webpackChunkName: "overview" */ "./views/Overview.vue"),
    meta: { title: "Overview", description: "overview", icon: dashboard },
  },
  {
    path: "/threat",
    name: "threat",
    component: () =>
      import(/* webpackChunkName: "threats" */ "./views/Threats.vue"),
    meta: { title: "Threats", description: "threats", icon: bug },
  },
  {
    path: "/agent",
    name: "agent",
    component: () =>
      import(/* webpackChunkName: "agents" */ "./views/Agents.vue"),
    meta: {
      title: "Agents",
      group: "agents",
      description: "agents",
      icon: deviceDesktop,
    },
  },

  {
    path: "/group",
    name: "group",
    component: () =>
      import(/* webpackChunkName: "config" */ "./views/ConfigurationGroup.vue"),
    meta: { title: "Groups", group: "agents", icon: versions },
  },

  {
    path: "/license",
    name: "license",
    component: () =>
      import(
        /* webpackChunkName: "config" */ "./views/ConfigurationLicense.vue"
      ),
    meta: { title: "Licenses", group: "agents", icon: verified },
  },
  {
    path: "/server",
    name: "server",
    component: () =>
      import(/* webpackChunkName: "authentication" */ "./views/Server.vue"),
    meta: { title: "Server", group: "agents", icon: server },
  },
  {
    path: "/server/create-server",
    name: "create-server",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/CreateServer.vue"
      ),
    meta: { show: false },
    props: true,
  },
  {
    path: "/create-server",
    name: "create-server-2",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/CreateServerV2.vue"
      ),
    meta: { show: false },
    props: true,
  },
  {
    path: "/update-server/:id",
    name: "update-server-2",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/UpdateServerV2.vue"
      ),
    meta: { show: false },
    props: true,
  },
  {
    path: "/server/update-server/:id",
    name: "update-server",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/UpdateServer.vue"
      ),
    meta: { show: false },
    props: true,
  },
  {
    path: "/policy",
    name: "policy",
    component: () =>
      import(/* webpackChunkName: "policies" */ "./views/Policies.vue"),
    meta: {
      title: "Policies",
      group: "management",
      description: "policies",
      icon: tasklist,
    },
  },
  {
    path: "/report",
    name: "report",
    component: () =>
      import(/* webpackChunkName: "report" */ "./views/Report.vue"),
    meta: {
      title: "Reports",
      group: "management",
      description: "report",
      icon: clippy,
    },
  },
  {
    path: "/alert",
    name: "alert",
    component: () =>
      import(/* webpackChunkName: "authentication" */ "./views/Alert.vue"),
    meta: { title: "Alerts", group: "management", icon: alert },
  },
  {
    path: "/intergration",
    name: "intergration",
    component: () =>
      import(/* webpackChunkName: "authentication" */ "./views/Collector.vue"),
    meta: { title: "Intergration", group: "management", icon: link },
  },
  {
    path: "/info",
    name: "info",
    component: () =>
      import(/* webpackChunkName: "config" */ "./views/ConfigurationInfo.vue"),
    meta: { title: "Info", group: "config", icon: info },
  },
  {
    path: "/user",
    name: "user",
    component: () =>
      import(/* webpackChunkName: "authentication" */ "./views/User.vue"),
    meta: { title: "Users", group: "config", icon: organization },
  },
  {
    path: "/update",
    name: "update",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/ConfigurationUpdate.vue"
      ),
    meta: { title: "Update", group: "config", icon: desktopDownload },
  },

  {
    path: "/create-version",
    name: "create-version-2",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/CreateVersionV2.vue"
      ),
    meta: { show: false },
    props: true,
  },

  {
    path: "/update-version/:id",
    name: "update-version-2",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/UpdateVersionV2.vue"
      ),
    meta: { show: false },
    props: true,
  },

  {
    path: "/settings",
    name: "settings",
    component: () =>
      import(/* webpackChunkName: "authentication" */ "./views/Settings.vue"),
    meta: { title: "Settings", group: "config", icon: settings },
  },
  {
    path: "/download",
    name: "download",
    component: () =>
      import(/* webpackChunkName: "download" */ "./views/Download.vue"),
    meta: {
      show: false,
      bare: true,
      public: true,
    },
  },
  {
    path: "/update-offline",
    name: "update-offline",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "./views/ConfigurationUpdateOffline.vue"
      ),
    meta: {
      title: "Offline Update",
      group: "config",
      icon: desktopDownload,
      show: false,
    },
  },

  {
    path: "/error-page",
    name: "error-page",
    component: () =>
      import(/* webpackChunkName: "authentication" */ "./views/ErrorPage.vue"),
    meta: {
      show: false,
      bare: true,
      public: true,
    },
  },
];

export default routes;
